/* Heads Up Crush — self-contained sticky BUY NOW bar.
   One-tap checkout engine + the mobile expandable plan picker, in one IIFE.
   Drop-in: needs #crush-buy-config + #crushBuyBar markup inside `.huh-shooting`,
   and crush-buybar.css. Independent of huh-crush.js (does NOT do scroll-reveal
   or count-up). Loaded with defer. */
(function () {
  'use strict';

  var root = document.querySelector('.huh-shooting');
  if (!root) return;

  /* ---------------------------------------------------------------- */
  /* Buy engine — one config, every buy trigger reuses it             */
  /* ---------------------------------------------------------------- */
  var CFG = null;
  var cfgEl = document.getElementById('crush-buy-config');
  if (cfgEl) {
    var attr = function (n) { return (cfgEl.getAttribute(n) || '').trim(); };
    CFG = {
      hardware: attr('data-hardware'),
      checkout: attr('data-checkout') || '/checkout',
      planHandles: attr('data-plan-handles').split(',').map(function (s) { return s.trim(); }).filter(Boolean),
      plans: {
        monthly:  { variant: attr('data-monthly-variant'),  plan: attr('data-monthly-plan'), hw: true },
        annual:   { variant: attr('data-annual-variant'),   plan: attr('data-annual-plan'),  hw: true },
        lifetime: { variant: attr('data-lifetime-variant'), plan: '',                         hw: false }
      }
    };
  }

  function toast(msg) {
    var t = document.getElementById('crush-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'crush-toast';
      t.className = 'crush-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      root.appendChild(t);
    }
    t.textContent = msg;
    void t.offsetWidth; // force reflow so re-showing re-animates
    t.classList.add('show');
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.classList.remove('show'); }, 5200);
  }

  function setBusy(btn, on) {
    if (!btn) return;
    if (on) {
      if (btn._label == null) btn._label = btn.innerHTML;
      btn.classList.add('is-busy');
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      btn.innerHTML = '<span class="crush-spin" aria-hidden="true"></span><span>Working…</span>';
    } else {
      btn.classList.remove('is-busy');
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
      if (btn._label != null) { btn.innerHTML = btn._label; btn._label = null; }
    }
  }

  function jpost(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    });
  }

  /* 13 Oct 2026: full-screen "Taking you to checkout" overlay that shows what is being bought and the price,
     so a tap is never silent on a slow phone. Hidden again after 15 s if we are somehow still here. */
  function goingOverlay(planKey) {
    var bar = document.getElementById('crushBuyBar');
    var data = function (k) { return bar ? (bar.getAttribute(k) || '') : ''; };
    var names = { annual: 'Crush Annual', monthly: 'Crush Monthly', lifetime: 'Crush Lifetime' };
    var amt = data('data-amt-' + planKey), per = data('data-per-' + planKey), note = data('data-note-' + planKey);
    var o = document.getElementById('crush-going');
    if (!o) {
      o = document.createElement('div'); o.id = 'crush-going'; o.className = 'crush-going';
      o.setAttribute('role', 'status'); o.setAttribute('aria-live', 'polite');
      o.innerHTML = '<div class="crush-going-card"><span class="crush-spin crush-spin-lg" aria-hidden="true"></span>' +
        '<div class="crush-going-title">Taking you to checkout\u2026</div><div class="crush-going-plan"></div>' +
        '<div class="crush-going-price"></div><div class="crush-going-note"></div></div>';
      document.body.appendChild(o);
    }
    o.querySelector('.crush-going-plan').textContent = names[planKey] || '';
    o.querySelector('.crush-going-price').textContent = amt ? (amt + (per ? ' ' + per : '')) : '';
    o.querySelector('.crush-going-note').innerHTML = note;
    o.classList.add('show');
    clearTimeout(o._h); o._h = setTimeout(function () { o.classList.remove('show'); }, 15000);
  }
  function hideGoing() { var o = document.getElementById('crush-going'); if (o) o.classList.remove('show'); }

  var buying = false;
  function crushBuy(planKey, btn, dest) {
    if (buying) return;
    if (!CFG) { toast('Checkout isn\u2019t set up yet.'); return; }
    var plan = CFG.plans[planKey];
    if (!plan || !plan.variant) { toast('That plan isn\u2019t available right now.'); return; }
    buying = true;
    setBusy(btn, true);
    goingOverlay(planKey);
    function finish(destination) {
      if (window.huhSeasonOffer) {
        destination = window.huhSeasonOffer.checkoutUrl(destination);
        return window.huhSeasonOffer.apply().catch(function () {}).then(function () { window.location.assign(destination); });
      }
      window.location.assign(destination);
    }
    /* 13 Oct 2026: one-time plans (Lifetime) make NO cart calls - a cart permalink goes straight to checkout */
    if (!plan.plan && !plan.hw) { finish('/cart/' + plan.variant + ':1'); return; }
    var toAdd = [];
    if (plan.hw && CFG.hardware) toAdd.push({ id: parseInt(CFG.hardware, 10), quantity: 1 });
    var item = { id: parseInt(plan.variant, 10), quantity: 1 };
    if (plan.plan) item.selling_plan = parseInt(plan.plan, 10);
    toAdd.push(item);
    /* subscription plans: two calls (was three - the cart read is gone), then checkout */
    jpost('/cart/clear.js')
      .then(function () { return jpost('/cart/add.js', { items: toAdd }); })
      .then(function (res) {
        if (!res.ok) {
          return res.json().catch(function () { return {}; }).then(function (d) {
            throw new Error(d.description || d.message || ('HTTP ' + res.status));
          });
        }
        return finish(dest || CFG.checkout || '/checkout');
      })
      .catch(function (err) {
        buying = false;
        setBusy(btn, false);
        hideGoing();
        toast(err && err.message ? err.message : 'Something went wrong \u2014 please try again.');
      });
  }

  // Delegated handler for every buy trigger inside .huh-shooting.
  // [data-buy] → checkout (the sticky bar). [data-buy-cart] → /cart (the plan cards).
  root.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-buy],[data-buy-cart]') : null;
    if (!b || !root.contains(b)) return;
    e.preventDefault();
    if (b.hasAttribute('data-buy-cart')) {
      crushBuy(b.getAttribute('data-buy-cart'), b, '/cart');
    } else {
      crushBuy(b.getAttribute('data-buy'), b);
    }
  });

  /* ---------------------------------------------------------------- */
  /* Sticky buy bar — plan toggle + show/hide + mobile expand         */
  /* ---------------------------------------------------------------- */
  var bar = document.getElementById('crushBuyBar');
  if (bar) {
    var hero = root.querySelector('.crush-cover') || root.querySelector('.hero-cover');
    var pricing = document.getElementById('pricing');
    var toggle = bar.querySelector('.cbb-toggle');
    var segs = bar.querySelectorAll('.cbb-seg');
    var note = bar.querySelector('[data-cbb-note]');
    var amtEl = bar.querySelector('[data-cbb-amt]');
    var perEl = bar.querySelector('[data-cbb-per]');
    var buyBtn = bar.querySelector('.cbb-buy');
    var mqMobile = window.matchMedia('(max-width: 720px)');
    var data = function (k) { return bar.getAttribute(k) || ''; };
    var notes = { annual: data('data-note-annual'), monthly: data('data-note-monthly'), lifetime: data('data-note-lifetime') };
    var amts  = { annual: data('data-amt-annual'),  monthly: data('data-amt-monthly'),  lifetime: data('data-amt-lifetime') };
    var pers  = { annual: data('data-per-annual'),   monthly: data('data-per-monthly'),  lifetime: data('data-per-lifetime') };

    function selectPlan(plan) {
      var idx = 0;
      segs.forEach(function (sg, i) {
        var on = sg.getAttribute('data-cbb-plan') === plan;
        if (on) idx = i;
        sg.classList.toggle('is-active', on);
        sg.setAttribute('aria-checked', on ? 'true' : 'false');
        sg.tabIndex = on ? 0 : -1;
      });
      if (toggle) toggle.style.setProperty('--cbb-i', idx);
      if (buyBtn && buyBtn._label == null) buyBtn.setAttribute('data-buy', plan);
      if (note) note.innerHTML = notes[plan] || '';
      if (amtEl) amtEl.textContent = amts[plan] || '';
      if (perEl) perEl.textContent = pers[plan] || '';
    }

    segs.forEach(function (sg) {
      sg.addEventListener('click', function () { selectPlan(sg.getAttribute('data-cbb-plan')); });
    });

    if (toggle) {
      toggle.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        var order = ['annual', 'monthly', 'lifetime'];
        var cur = buyBtn ? buyBtn.getAttribute('data-buy') : 'annual';
        var i = order.indexOf(cur); if (i < 0) i = 0;
        var next = order[(i + (e.key === 'ArrowRight' ? 1 : order.length - 1)) % order.length];
        selectPlan(next);
        var el = bar.querySelector('.cbb-seg[data-cbb-plan="' + next + '"]');
        if (el) el.focus();
      });
    }

    var shown = false, ticking = false, dismissed = false;
    var closeBtn = bar.querySelector('.cbb-close');

    function setExpanded(open) {
      bar.classList.toggle('cbb-open', !!open);
      if (buyBtn && mqMobile.matches) buyBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    // On a phone the collapsed Buy-now pill opens the picker first (it doesn't check out yet);
    // once expanded — or on desktop — it completes the purchase via the delegated [data-buy] handler.
    if (buyBtn) buyBtn.addEventListener('click', function (e) {
      if (mqMobile.matches && !bar.classList.contains('cbb-open')) {
        e.preventDefault(); e.stopPropagation();
        setExpanded(true);
      }
    });

    if (closeBtn) closeBtn.addEventListener('click', function () {
      if (mqMobile.matches && bar.classList.contains('cbb-open')) { setExpanded(false); return; }
      dismissed = true; shown = false;
      bar.classList.remove('is-visible');
      bar.setAttribute('aria-hidden', 'true');
    });

    function compute() {
      ticking = false;
      if (dismissed) return;
      var sc = window.pageYOffset || document.documentElement.scrollTop || 0;
      var vh = window.innerHeight || 0;
      var heroH = hero ? hero.offsetHeight : 0;
      var pTop = pricing ? (pricing.getBoundingClientRect().top + sc) : Infinity;
      var want = (sc > heroH * 0.55) && (sc + vh < pTop + 80);
      if (want !== shown) {
        shown = want;
        bar.classList.toggle('is-visible', want);
        bar.setAttribute('aria-hidden', want ? 'false' : 'true');
        if (!want) setExpanded(false);
      }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(compute); } }

    selectPlan(bar.getAttribute('data-default') || 'annual');
    setExpanded(false);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    compute();
  }
})();
